import { Component } from '@angular/core';

@Component({
  selector: 'msgm-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {}
